"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Avatar
 *
 * This component can show a user's avatar or their initials,
 * size color and border are all customizable.
 * 
 * @component
 * @category Molecules
 */
var Avatar = function Avatar(props) {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      imgError = _useState2[0],
      setImgError = _useState2[1];

  var s = props.size ? parseInt(props.size, 10) : 40;
  var fontSize = s * (15 / 40) + 'px';
  var bg = props.background ? "var(--".concat(props.background, ")") : "var(--grey3-color)";
  var color = props.color ? props.color : _atoms.Color.Grey1;
  var border = props.border ? "var(--".concat(props.border, ")") : "transparent";
  var containerStyles = {
    width: s,
    height: s,
    background: bg
  };

  if (props.outerBorderColor) {
    containerStyles.borderColor = "var(--".concat(props.outerBorderColor, ")");
    containerStyles.borderWidth = 2;
    containerStyles.borderStyle = 'solid';
  }

  if (props.styles) {
    containerStyles = Object.assign({}, containerStyles, props.styles);
  }

  var textStyles = {
    borderColor: border,
    fontSize: 15 / 40 * s
  };

  if (border !== 'transparent') {
    textStyles.borderWidth = 4;
    textStyles.borderStyle = 'solid';
  }

  var imgStyles = Object.assign({}, textStyles);

  if (imgError) {
    imgStyles.display = 'none';
  }

  var attr = _objectSpread(_objectSpread({}, props), {}, {
    initials: null,
    size: null,
    imageUrl: null,
    background: null,
    color: null,
    border: null,
    fullName: null,
    outerBorderColor: null,
    title: props.fullName,
    style: containerStyles
  });

  var cn = "Avatar";

  if (props.className) {
    cn += " " + props.className;
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({}, attr, {
    className: cn
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "initials",
    tag: "span",
    content: props.initials,
    color: color,
    bold: true,
    size: fontSize,
    style: textStyles
  }), props.imageUrl && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    tag: "img",
    src: props.imageUrl,
    alt: props.initials,
    style: imgStyles,
    onError: function onError(e) {
      return setImgError(true);
    }
  }), props.children);
};

exports.Avatar = Avatar;
Avatar.propTypes = {
  /* The full name of the user to display. */
  fullName: _propTypes.default.string,

  /* The initials of the user to display if no imageUrl is provided. */
  initials: _propTypes.default.string,

  /* The size of the avatar. This will be its height and width. */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /* The avatar image to display */
  imageUrl: _propTypes.default.string,

  /* The background color behind the image. Default is Grey3 */
  background: _propTypes.default.string,

  /* The border color, defaults to same as background */
  borderColor: _propTypes.default.string,

  /* The outer circle border color */
  outerBorderColor: _propTypes.default.string,

  /* The text color, defaults to Grey1 */
  color: _propTypes.default.string
};